import { useEffect } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

import { LISCase } from "pwapi";

import { PresenceProvider } from "shared/hooks/PresenceProvider";
import { useIsLoading } from "shared/hooks/requestStatusHooks";
import { selectFeatureFlag } from "shared/reducers/sysReducer";

import { getCaseForDocument } from "app/actions/documentActions";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { useSelectedLabStation } from "hooks/useSelectedLabStation";
import AppSpinner from "ui/components/AppSpinner";

import GrossingStationSpecimen from "./GrossingStationSpecimen";

const GrossingStationSpecimenGate = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const params = useParams();
  const [document_id, specimen_id] = [
    Number(params.document_id),
    Number(params.specimen_id),
  ];
  const selectedLabStation = useSelectedLabStation();

  const pathCase = useAppSelector((state) => state.case);
  const document = pathCase?.documents?.find((d) => d.id === document_id);
  const specimen = pathCase?.specimens?.find((s) => s.id === specimen_id);

  const getCaseArgs = {
    parentLookupLabStationId: selectedLabStation.id,
    id: document_id,
  };

  const adminPresenceDetectionFlag = useAppSelector((state) =>
    selectFeatureFlag(state, "adminPresenceDetection")
  );

  const loadingCase = useIsLoading(getCaseForDocument, getCaseArgs);

  useEffect(() => {
    if (!loadingCase && !document) {
      dispatch(getCaseForDocument(getCaseArgs))
        .then((response: LISCase) => {
          if (!response.specimens.some((s) => s.id === specimen_id)) {
            toast.error("Specimen Not Found");
            navigate(`/station/grossing/document/${document_id}/`);
          }
        })
        .catch((error) => {
          toast.error(error.message);
          navigate("/station/grossing/");
        });
    }
  }, [document_id]);

  if (loadingCase || !pathCase || !document || !specimen) {
    return <AppSpinner>Loading Grossing Details...</AppSpinner>;
  } else {
    return (
      <PresenceProvider
        slug={`case-${pathCase.id}/grossing`}
        presenceDetectionEnabled={adminPresenceDetectionFlag}
      >
        <GrossingStationSpecimen
          key={
            specimen.id
          } /* use Specimen ID as the key prop to force remounting when Specimen changes */
          pathCase={pathCase}
          specimen={specimen}
          document={document}
        />
      </PresenceProvider>
    );
  }
};

export default GrossingStationSpecimenGate;
